// extracted by mini-css-extract-plugin
export default {"container":"SuccessPage_container__iIkWk","card":"SuccessPage_card__1vMB-","h2":"SuccessPage_h2__f6ITt","p":"SuccessPage_p__Y4fo+","link":"SuccessPage_link__mqqoU"};